import size from 'lodash/size';
import {getValueAdaptData, getValueAdaptSources} from "~/stateGetter";
import {
    getModelsWithChangedData, isFieldValueEqual, normalizeValueDependencies, presentFieldValue,
    prepareComparableOneFieldValue,
} from "~/statePresenter";
import loadModelPath from "~/reducers/helpers/loadModelPath";

export default function isPathDiscardingData(state, path, changeRootModel, noConfirm) {
    let changedModels = getModelsWithChangedData(state);

    if(size(changedModels) < 1) { return false; }
    if(changeRootModel) { return true; }

    let simulatedUi = loadModelPath(state.ui, path, changeRootModel, noConfirm, state),
        simulatedModels = simulatedUi.loadedModels,
        simulatedState = { ...state, ui: simulatedUi };
    
    for(let modelId in changedModels) {
        if(!changedModels.hasOwnProperty(modelId)) { continue; }

        if(!(modelId in simulatedModels)) {
            return true;        
        }

        let { updatedValues } = changedModels[modelId];

        let simulatedValueAdaptProps = {
            ...getValueAdaptData(simulatedState, modelId),
            ...getValueAdaptSources(simulatedState, modelId)
        };

        simulatedValueAdaptProps = { ...simulatedValueAdaptProps,  ...normalizeValueDependencies(simulatedValueAdaptProps) };

        for(let name in updatedValues) {
            if(!updatedValues.hasOwnProperty(name)) { continue; }
            
            let value = updatedValues[name],
                simulatedValue = prepareComparableOneFieldValue(
                    simulatedValueAdaptProps.editFields[name],
                    presentFieldValue(simulatedValueAdaptProps.editFields[name], simulatedValueAdaptProps)
                );
            
            if(!isFieldValueEqual(value, simulatedValue)) {
                return true;
            }
        }        
    }
    
    return false;
}